(() => {
  if (!document.documentElement.lang.startsWith('ar')) return;
  const bound = new WeakSet();
  const setText = (node, text) => {
    if (node && node.textContent !== text) node.textContent = text;
  };
  const translate = (root) => {
    root.querySelectorAll('.bndlr-quantity-break').forEach((widget) => {
      setText(widget.querySelector('.bndlr-line'), 'اختار عدد العبوات');
      widget.querySelectorAll('.bndlr-radio-container').forEach((option) => {
        const quantity = Number(option.querySelector('[name="bundle_quantity"]')?.value);
        if (quantity > 0) {
          const label = quantity === 1 ? 'عبوة واحدة' : quantity === 2 ? 'عبوتين' : `${quantity} عبوات`;
          setText(option.querySelector('.bndlr-text'), label);
        }
        const saving = option.querySelector('.bndlr-savings-text');
        if (saving) setText(saving, saving.textContent.replace(/^Save\s*/i, 'وفّر ').replace(/EGP!?/gi, ' جنيه').replace(/!$/, ''));
      });
    });
  };
  const bind = () => {
    document.querySelectorAll('[data-zyma-bundler-native]').forEach((root) => {
      if (bound.has(root)) return;
      bound.add(root);
      new MutationObserver(() => translate(root)).observe(root, { childList: true, subtree: true });
      translate(root);
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
